// Auto-generated configuration file
// Generated at: 2026-11-03T17:39:35.700Z
// Environment: prod
// Multi-domain configuration: msl, sym

export const runtimeConfig = {
  "isMultiDomain": true,
  "environment": "prod",
  "domains": {
    "msl": {
      "apiKey": "",
      "hubspotUrl": "https://symplelending.com",
      "hubspotPortalId": "44977415",
      "hubspotForms": {
        "email": "283760521",
        "birthdate": "283760522",
        "phone": "283760523",
        "scheduledcall": "283760524"
      },
      "apiBaseUrl": "https://core.sympleservices.io",
      "offersUrl": "https://offers.symplelending.com",
      "useBff": true,
      "trustpilotBusinessUnitId": "6254caf25ce7d4b7427851cc",
      "trustpilotDomain": "mysympleloan.com",
      "gtmContainer": {
        "url": "https://s.mysympleloan.com",
        "iId": "faelrpzkg",
        "cId": "1y3=Dg9HNyYhSDZVOTAhOF8nRxFWSF5DSgEPWgYDAwsBFQ0CBxURHEIGDgo%3D",
        "containerId": "GTM-W2RJQJ3B"
      },
      "rumApplicationId": "4e51f483-a743-4f68-9160-83cb2ff016ba",
      "mockServices": false,
      "debug": false,
      "environment": "prod",
      "analytics": {
        "enabled": true,
        "googleTagManager": true,
        "hubspot": true,
        "trustpilot": true
      },
      "awsRum": {
        "identityPoolId": "us-east-1:04276d05-078b-445f-80f0-dec57fa6b37c",
        "region": "us-east-1",
        "enabled": true
      }
    },
    "sym": {
      "apiKey": "",
      "hubspotUrl": "https://symplelending.com",
      "hubspotPortalId": "44977415",
      "hubspotForms": {
        "email": "283760521",
        "birthdate": "283760522",
        "phone": "283760523",
        "scheduledcall": "283760524"
      },
      "apiBaseUrl": "https://core.sympleservices.io",
      "offersUrl": "https://offers.symplelending.com",
      "useBff": true,
      "trustpilotBusinessUnitId": "60746c04f2eabb000133f66d",
      "trustpilotDomain": "symplelending.com",
      "gtmContainer": {
        "url": "https://s.symplelending.com",
        "iId": "ewsrxnzcw",
        "cId": "egxxq7zb=HgdHKSw%2FXiBFMTA%2FMkExUQFeSEBJVBcZShADAwgeFhsSDR4HFhVdFBgO",
        "containerId": "GTM-W2RJQJ3B"
      },
      "rumApplicationId": "df30c990-7e03-48fe-8d83-d668fa255d53",
      "mockServices": false,
      "debug": false,
      "environment": "prod",
      "analytics": {
        "enabled": true,
        "googleTagManager": true,
        "hubspot": true,
        "trustpilot": true
      },
      "awsRum": {
        "identityPoolId": "us-east-1:04276d05-078b-445f-80f0-dec57fa6b37c",
        "region": "us-east-1",
        "enabled": true
      }
    }
  }
} as const;

// Type definitions for multi-domain configuration
export type DomainType = 'msl' | 'sym';

export type DomainConfig = {
  apiKey: string;
  hubspotUrl: string;
  hubspotPortalId: string;
  hubspotForms: {
    email: string;
    birthdate: string;
    phone: string;
    scheduledcall: string;
  };
  apiBaseUrl: string;
  offersUrl: string;
  useBff?: boolean;
  bffBaseUrl?: string;
  trustpilotBusinessUnitId: string;
  trustpilotDomain: string;
  gtmContainerId?: string;
  gtmContainer?: {
    url: string;
    iId: string;
    cId: string;
    containerId: string;
  };
  rumApplicationId: string;
  mockServices: boolean;
  debug: boolean;
  environment: string;
  analytics: {
    enabled: boolean;
    googleTagManager: boolean;
    hubspot: boolean;
    trustpilot: boolean;
  };
  awsRum: {
    identityPoolId: string;
    region: string;
    enabled: boolean;
  };
};

export type MultiDomainRuntimeConfig = {
  isMultiDomain: true;
  environment: string;
  domains: Record<DomainType, DomainConfig>;
};

export type RuntimeConfig = MultiDomainRuntimeConfig | DomainConfig;
